export type SidebarLink = {
    type: 'link';
    to: string;
    labelKey?: string;
    label?: string;
};

export type SidebarGroup = {
    type: 'group';
    id: string;
    titleKey?: string;
    title?: string;
    children: SidebarChild[];
    sort?: 'alpha' | 'alphaDeleteLast' | 'none';
};

export type SidebarChild = SidebarLink | SidebarGroup;

export type SidebarItem = SidebarLink | SidebarGroup;

export type SidebarSection = {
    id: string;
    title: string;
    items: SidebarItem[];
};

export const SIDEBAR_SECTIONS: SidebarSection[] = [
    {
        id: 'core',
        title: 'Core',
        items: [
            { type: 'link', to: '/userDetail', labelKey: 'resources.userDetail.name' },
            {
                type: 'link',
                to: '/giftCardTransactionDetailsPage',
                labelKey: 'resources.giftCardTransactionDetailsPage.name',
            },
            { type: 'link', to: '/amlChecks', labelKey: 'resources.amlChecks.name' },
            {
                type: 'link',
                to: '/updateGiftCardBlackList',
                labelKey: 'resources.updateGiftCardBlackList.name',
            },
        ],
    },
    {
        id: 'operations',
        title: 'Operations',
        items: [
            {
                type: 'group',
                id: 'mortgage',
                titleKey: 'resources.mortgage.name',
                sort: 'alpha',
                children: [
                    {
                        type: 'link',
                        to: '/addressAndCreditReport',
                        labelKey: 'resources.addressAndCreditReport.name',
                    },
                    {
                        type: 'link',
                        to: '/generateBrokerReport',
                        labelKey: 'resources.generateBrokerReport.name',
                    },
                    {
                        type: 'link',
                        to: '/pullCreditFile',
                        labelKey: 'resources.pullCreditFile.name',
                    },
                    {
                        type: 'link',
                        to: '/UserMortgageData',
                        labelKey: 'resources.UserMortgageData.name',
                    },
                    {
                        type: 'link',
                        to: '/hybridMortgageUpdate',
                        labelKey: 'resources.hybridMortgageUpdate.name',
                    },
                    {
                        type: 'link',
                        to: '/mortgageKycDebug',
                        label: 'Mortgage KYC Debug',
                    },
                ],
            },
            {
                type: 'group',
                id: 'marketing',
                title: 'Marketing',
                sort: 'alpha',
                children: [
                    {
                        type: 'link',
                        to: '/applyPromoReferralCode',
                        labelKey: 'resources.applyPromoReferralCode.name',
                    },
                    {
                        type: 'link',
                        to: '/createPromocode',
                        labelKey: 'resources.createPromocode.name',
                    },
                    {
                        type: 'link',
                        to: '/promoCodeRecords',
                        labelKey: 'resources.promocodeRecords.name',
                    },
                    {
                        type: 'link',
                        to: '/promoBannerConfig',
                        labelKey: 'resources.promoBannerConfig.name',
                    },
                ],
            },
            {
                type: 'group',
                id: 'referral',
                title: 'Referral',
                sort: 'none',
                children: [
                    {
                        type: 'link',
                        to: '/referralConfig',
                        labelKey: 'resources.referralConfig.name',
                    },
                    {
                        type: 'link',
                        to: '/prizeDrawConfig',
                        labelKey: 'resources.prizeDrawConfig.name',
                    },
                    {
                        type: 'link',
                        to: '/referralPromoBannerConfig',
                        labelKey: 'resources.referralPromoBannerConfig.name',
                    },
                    {
                        type: 'link',
                        to: '/referralUserTracking',
                        labelKey: 'resources.referralUserTracking.name',
                    },
                    {
                        type: 'link',
                        to: '/referralFraudReview',
                        labelKey: 'resources.referralFraudReview.name',
                    },
                    {
                        type: 'link',
                        to: '/brandHaircutConfig',
                        labelKey: 'resources.brandHaircutConfig.name',
                    },
                ],
            },
            {
                type: 'group',
                id: 'user-operations',
                title: 'User Operations',
                sort: 'alphaDeleteLast',
                children: [
                    { type: 'link', to: '/autoSaveDashboard', label: 'Auto-Save Dashboard' },
                    {
                        type: 'link',
                        to: '/userInflightDetails',
                        labelKey: 'resources.userInflightDetails.name',
                    },
                    { type: 'link', to: '/boostAward', label: 'User Boost' },
                    { type: 'link', to: '/transferReferrals', label: 'Transfer Referrals' },
                    { type: 'link', to: '/challengeDashboard', label: 'Challenge Dashboard' },
                    { type: 'link', to: '/newUserBoostDashboard', label: 'First Thirty Days' },
                    {
                        type: 'link',
                        to: '/accountClosure',
                        labelKey: 'resources.accountClosure.name',
                    },
                    {
                        type: 'link',
                        to: '/accountRestore',
                        labelKey: 'resources.accountRestore.name',
                    },
                    {
                        type: 'link',
                        to: '/changeGiftCardState',
                        labelKey: 'resources.changeGiftCardState.name',
                    },
                    {
                        type: 'link',
                        to: '/deleteVrpConsent',
                        labelKey: 'resources.deleteVrpConsent.name',
                    },
                    {
                        type: 'link',
                        to: '/dupeAccountCheck',
                        labelKey: 'resources.dupeAccountCheck.name',
                    },
                    {
                        type: 'link',
                        to: '/forcedLogoutUser',
                        labelKey: 'resources.forcedLogoutUser.name',
                    },
                    {
                        type: 'link',
                        to: '/adminEwalletRegistration',
                        labelKey: 'resources.adminEwalletRegistration.name',
                    },
                    {
                        type: 'link',
                        to: '/getVerificationLink',
                        labelKey: 'resources.getVerificationLink.name',
                    },
                    {
                        type: 'link',
                        to: '/moveAccountRewards',
                        labelKey: 'resources.moveAccountRewards.name',
                    },
                    {
                        type: 'link',
                        to: '/removePinForUser',
                        labelKey: 'resources.removePinForUser.name',
                    },
                    {
                        type: 'link',
                        to: '/removeBiometricsForUser',
                        labelKey: 'resources.removeBiometricsForUser.name',
                    },
                    {
                        type: 'link',
                        to: '/removeUserFromSuppressionList',
                        labelKey: 'resources.removeUserFromSuppressionList.name',
                    },
                    {
                        type: 'link',
                        to: '/superChargedCalculator',
                        labelKey: 'resources.superChargedCalculator.name',
                    },
                    {
                        type: 'link',
                        to: '/transferRewardAmount',
                        labelKey: 'resources.transferRewardAmount.name',
                    },
                    {
                        type: 'link',
                        to: '/updateDirectDebit',
                        labelKey: 'resources.updateDirectDebit.name',
                    },
                    {
                        type: 'link',
                        to: '/updatePayToLender',
                        labelKey: 'resources.updatePayToLender.name',
                    },
                    {
                        type: 'link',
                        to: '/updatePendingTask',
                        labelKey: 'resources.updatePendingTask.name',
                    },
                    {
                        type: 'link',
                        to: '/updateUser',
                        labelKey: 'resources.updateUser.name',
                    },
                    {
                        type: 'link',
                        to: '/updatePaymentReference',
                        labelKey: 'resources.updatePaymentReference.name',
                    },
                    {
                        type: 'link',
                        to: '/updateUserPendingAction',
                        labelKey: 'resources.updateUserPendingAction.name',
                    },
                    { type: 'link', to: '/userSessionInfo', label: 'User Session Info' },
                    {
                        type: 'link',
                        to: '/vdxDashboard',
                        labelKey: 'resources.vdxDashboard.name',
                    },
                    {
                        type: 'link',
                        to: '/partnerizeUserActivity',
                        labelKey: 'resources.partnerizeUserActivity.name',
                    },
                    {
                        type: 'link',
                        to: '/awinUserActivity',
                        labelKey: 'resources.awinUserActivity.name',
                    },
                    {
                        type: 'link',
                        to: '/affiliateUserActivity',
                        labelKey: 'resources.affiliateUserActivity.name',
                    },
                    {
                        type: 'link',
                        to: '/natwestTransfer',
                        labelKey: 'resources.natwestTransfer.name',
                    },
                    {
                        type: 'link',
                        to: '/updateGiftCardTransaction',
                        labelKey: 'resources.updateGiftCardTransaction.name',
                    },
                    {
                        type: 'link',
                        to: '/deleteUser',
                        labelKey: 'resources.deleteUser.name',
                    },
                ],
            },
            {
                type: 'group',
                id: 'brand-catalog',
                title: 'Brand Catalog',
                sort: 'none',
                children: [
                    { type: 'link', to: '/brandCatalogVdxMerchants', label: 'VDX Merchants' },
                    { type: 'link', to: '/brandCatalogTilloHealth', label: 'Tillo Health' },
                    { type: 'link', to: '/brandCatalogTilloOverride', label: 'Tillo Override' },
                    {
                        type: 'group',
                        id: 'brand-catalog-clo',
                        title: 'CLO',
                        sort: 'none',
                        children: [
                            { type: 'link', to: '/cloConfig', label: 'Campaign & Merchant Config' },
                            { type: 'link', to: '/cloCohorts', label: 'Open Banking & Cohorts' },
                            { type: 'link', to: '/clo/transactions', label: 'Transactions' },
                            { type: 'link', to: '/clo/billing', label: 'Billing & Invoicing' },
                            { type: 'link', to: '/clo/wallets', label: 'Wallets' },
                        ],
                    },
                ],
            },
            {
                type: 'group',
                id: 'gift-cards',
                title: 'Gift Cards',
                sort: 'none',
                children: [
                    {
                        type: 'link',
                        to: '/giftCardBrands',
                        labelKey: 'resources.giftCardBrands.name',
                    },
                    {
                        type: 'link',
                        to: '/giftCardBrandManagement',
                        labelKey: 'resources.giftCardBrandManagement.name',
                    },
                    { type: 'link', to: '/cancelVoucher', label: 'Cancel Voucher' },
                    { type: 'link', to: '/cancellationHistory', label: 'Cancellation History' },
                    { type: 'link', to: '/giftcardlossabsorbed', label: 'Loss Absorbed' },
                    { type: 'link', to: '/giftCardTopupsDashboard', label: 'Top Ups' },
                    { type: 'link', to: '/shopGridCategories', label: 'Shop Grid' },
                ],
            },
            {
                type: 'link',
                to: '/mastercardAnywhere',
                label: 'Anywhere Card Dashboard',
            },
            {
                type: 'link',
                to: '/mastercardAnywhereAccess',
                label: 'Anywhere Access',
            },
            {
                type: 'link',
                to: '/vdxMerchants',
                labelKey: 'resources.vdxMerchants.name',
            },
            {
                type: 'link',
                to: '/vdxClaimForm',
                labelKey: 'resources.vdxClaimForm.name',
            },
            {
                type: 'link',
                to: '/partnerizeBrands',
                labelKey: 'resources.partnerizeBrands.name',
            },
            {
                type: 'link',
                to: '/awinBrands',
                labelKey: 'resources.awinBrands.name',
            },
            {
                type: 'group',
                id: 'device-authentication',
                title: 'Device Authentication',
                sort: 'none',
                children: [
                    {
                        type: 'link',
                        to: '/manageUserPasskeys',
                        labelKey: 'resources.manageUserPasskeys.name',
                    },
                    {
                        type: 'link',
                        to: '/manageDeviceSignatures',
                        labelKey: 'resources.manageDeviceSignatures.name',
                    },
                ],
            },
            {
                type: 'group',
                id: 'fraud',
                title: 'Fraud',
                sort: 'none',
                children: [
                    {
                        type: 'link',
                        to: '/fraudReview',
                        labelKey: 'resources.fraudReview.name',
                    },
                ],
            },
            {
                type: 'group',
                id: 'tech-operations',
                title: 'Tech Operations',
                sort: 'alpha',
                children: [
                    {
                        type: 'link',
                        to: '/constantsKeyValueDashboard',
                        labelKey: 'resources.constantsKeyValueDashboard.name',
                    },
                    {
                        type: 'link',
                        to: '/featureFlagDashboard',
                        labelKey: 'resources.featureFlagDashboard.name',
                    },
                    {
                        type: 'link',
                        to: '/paymentProviderDashboard',
                        labelKey: 'resources.paymentProviderDashboard.name',
                    },
                    {
                        type: 'link',
                        to: '/loadMoneyPpsSandboxAccount',
                        labelKey: 'resources.loadMoneyPpsSandboxAccount.name',
                    },
                    {
                        type: 'link',
                        to: '/masterToUserWalletDashboard',
                        labelKey: 'resources.masterToUserWalletDashboard.name',
                    },
                    {
                        type: 'link',
                        to: '/ppsPayee',
                        labelKey: 'resources.ppsPayee.name',
                    },
                    {
                        type: 'link',
                        to: '/rewardsEwalletHistoryFetch',
                        labelKey: 'resources.rewardsEwalletHistoryFetch.name',
                    },
                    {
                        type: 'link',
                        to: '/truelayerSyncFailureMonitor',
                        labelKey: 'resources.truelayerSyncFailureMonitor.name',
                    },
                    {
                        type: 'link',
                        to: '/manageLinkedAccount',
                        labelKey: 'resources.manageLinkedAccount.name',
                    },
                    {
                        type: 'link',
                        to: '/vdxBrandUrlTest',
                        labelKey: 'resources.vdxBrandUrlTest.name',
                    },
                ],
            },
            {
                type: 'group',
                id: 'finance',
                title: 'Finance',
                sort: 'alpha',
                children: [
                    {
                        type: 'link',
                        to: '/ppsMoneyManagement',
                        labelKey: 'resources.ppsMoneyManagement.name',
                    },
                    {
                        type: 'link',
                        to: '/tilloFloat',
                        labelKey: 'resources.tilloFloat.name',
                    },
                    {
                        type: 'link',
                        to: '/neocurrencyTopup',
                        labelKey: 'resources.neocurrencyTopup.name',
                    },
                    {
                        type: 'link',
                        to: '/natwestInternalTransfer',
                        labelKey: 'resources.natwestInternalTransfer.name',
                    },
                ],
            },
            {
                type: 'group',
                id: 'kpi',
                title: 'KPI',
                sort: 'alpha',
                children: [
                    {
                        type: 'link',
                        to: '/admin/grid',
                        labelKey: 'resources.grid.name',
                    },
                    {
                        type: 'link',
                        to: '/display-payments',
                        labelKey: 'resources.userPayments.name',
                    },
                ],
            },
            {
                type: 'group',
                id: 'archive',
                title: 'Archive Items',
                sort: 'alpha',
                children: [
                    {
                        type: 'link',
                        to: '/dashboard',
                        labelKey: 'resources.dashboard.name',
                    },
                    {
                        type: 'link',
                        to: '/homeValuation',
                        labelKey: 'resources.homeValuation.name',
                    },
                    {
                        type: 'link',
                        to: '/giftCardDashboard',
                        labelKey: 'resources.giftCardDashboard.name',
                    },
                    {
                        type: 'link',
                        to: '/pnNotifier',
                        labelKey: 'resources.pnNotifier.name',
                    },
                    {
                        type: 'link',
                        to: '/admin/monitor-debit-algo-performance',
                        labelKey: 'resources.debitCalculator.name',
                    },
                    {
                        type: 'link',
                        to: '/admin/inactive-users',
                        labelKey: 'resources.userSessionInfo.name',
                    },
                    {
                        type: 'link',
                        to: '/masterToEwalletFailure',
                        labelKey: 'resources.masterToEwalletFailure.name',
                    },
                    {
                        type: 'link',
                        to: '/redisCacheCleaner',
                        labelKey: 'resources.redisCacheCleaner.name',
                    },
                ],
            },
        ],
    },
    {
        id: 'admin',
        title: 'Admin',
        items: [
            {
                type: 'link',
                to: '/manageUser',
                label: 'Manage Admin Users',
            },
        ],
    },
];

export type TranslateFn = (key: string, options?: any) => string;

export const resolveLabel = (
    item: { labelKey?: string; label?: string },
    translate: TranslateFn
): string => {
    if (item.labelKey) {
        return translate(item.labelKey, { smart_count: 2 });
    }
    return item.label || '';
};

export const sortLinks = (
    children: SidebarChild[],
    sort: SidebarGroup['sort'] = 'none',
    translate: TranslateFn
): SidebarChild[] => {
    if (sort === 'none' || !sort) return children;
    const links = children.filter((c): c is SidebarLink => c.type === 'link');
    const groups = children.filter((c): c is SidebarGroup => c.type === 'group');
    return [...sortLinkList(links, sort, translate), ...groups];
};

const sortLinkList = (
    links: SidebarLink[],
    sort: SidebarGroup['sort'],
    translate: TranslateFn
): SidebarLink[] => {

    const withLabels = links.map((link) => ({
        link,
        primaryText: resolveLabel(link, translate),
    }));

    if (sort === 'alpha') {
        return withLabels
            .sort((a, b) => a.primaryText.localeCompare(b.primaryText))
            .map((x) => x.link);
    }

    // alphaDeleteLast
    return withLabels
        .sort((a, b) => {
            if (a.link.to === '/deleteUser') return 1;
            if (b.link.to === '/deleteUser') return -1;
            return a.primaryText.localeCompare(b.primaryText);
        })
        .map((x) => x.link);
};
